

export const flipCardToBack = ()=> {
    const fpInnerEl = document.getElementById('flip-card-inner');

    // fpEl.classList.add('flip-card--rot');
    fpInnerEl.classList.add('flip-card--rot');
}

export const flipCardToFront = ()=> {
    const fpInnerEl = document.getElementById('flip-card-inner');

    fpInnerEl.classList.remove('flip-card--rot');
}
